export default "__VITE_ASSET__Cqng1xHr__"